import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import ApiServices from '@/services/apiServices';


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileVersionList',
  setup(__props) {

const MobileVersionList = defineAsyncComponent(
    () => import('@/components/theme/town/MobileVersionList.vue'),
);

const route = useRoute();
const townId = computed(() => route.query.townId as string);
const townName = ref('');

onMounted(async () => {
    if (townId.value) {
        ApiServices.get('town', { id: townId.value }).then((response: any) => {
            townName.value = response?.name ?? '';
        });
    }
});

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Liste des villes",
      mains: "Liste des villes",
      title: _ctx.$t('mobileAppVersionList.title')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(MobileVersionList), {
          "town-id": townId.value,
          "town-name": townName.value
        }, null, 8, ["town-id", "town-name"])
      ])
    ])
  ], 64))
}
}

})